import { freezeWorkspaceProfile, type WorkspaceProfile } from "./workspace-model";

export interface WorkspacePreferencePort {
  loadAvailableProfiles(): Promise<readonly WorkspaceProfile[]>;
  saveOwnProfile(profile: WorkspaceProfile, expectedVersion: number): Promise<WorkspaceProfile>;
}

/** Default until the M25 preference API is composed; never falls back to browser layout storage. */
export const unavailableWorkspacePreferencePort: WorkspacePreferencePort = {
  loadAvailableProfiles: () => Promise.reject(new Error("M25_PREFERENCE_API_REQUIRED")),
  saveOwnProfile: () => Promise.reject(new Error("M25_PREFERENCE_API_REQUIRED")),
};

export class InMemoryWorkspacePreferencePort implements WorkspacePreferencePort {
  private profiles: WorkspaceProfile[];

  constructor(profiles: readonly WorkspaceProfile[] = []) {
    this.profiles = profiles.map(freezeWorkspaceProfile);
  }

  loadAvailableProfiles(): Promise<readonly WorkspaceProfile[]> {
    return Promise.resolve(this.profiles.map(freezeWorkspaceProfile));
  }

  saveOwnProfile(profile: WorkspaceProfile, expectedVersion: number): Promise<WorkspaceProfile> {
    if (profile.level !== "user") {
      return Promise.reject(new Error("ONLY_USER_PROFILE_WRITABLE"));
    }
    const current = this.profiles.find((item) => item.id === profile.id);
    if (current !== undefined && current.version !== expectedVersion) {
      return Promise.reject(new Error("WORKSPACE_VERSION_CONFLICT"));
    }
    const saved = freezeWorkspaceProfile({ ...profile, version: expectedVersion + 1 });
    this.profiles = [...this.profiles.filter((item) => item.id !== saved.id), saved];
    return Promise.resolve(saved);
  }
}
